<form [formGroup]="form" (submit)="submit()" a11yFocusTrap a11yAutoFocus>
    <vwui-modal-header>
        <h2 a11yPageTitleLevel="2">{{ title | translate }}</h2>
    </vwui-modal-header>
    <vwui-modal-body>
        <vwui-form-group label="{{ 'PAGE_PROJECT_LINKS.table.column.title' | translate }}" inputId="title" [required]="true">
            <vwui-input inputId="title"
                        formControlName="title"
                        placeholder="{{ 'PAGE_PROJECT_LINKS.placeholder.title' | translate }}">
            </vwui-input>
        </vwui-form-group>
        <vwui-form-group label="{{ 'PAGE_PROJECT_LINKS.table.column.link' | translate }}" inputId="link" [required]="true">
            <vwui-input inputId="link"
                        formControlName="link"
                        placeholder="{{ 'PAGE_PROJECT_LINKS.placeholder.link' | translate }}">
            </vwui-input>
        </vwui-form-group>
        @if (linkInvalid) {
            <div class="notification">
                <vwui-icon iconName="alert"></vwui-icon>
                {{ 'PAGE_PROJECT_LINKS.invalid_link' | translate }}
            </div>
        }
    </vwui-modal-body>
    <vwui-modal-footer>
        <vwui-button class="is-light" (click)="modalRef.close()">
            {{ 'BUTTON.cancel' | translate }}
        </vwui-button>
        <vwui-button class="is-primary" (click)="submit()">
            {{ saveText | translate }}
        </vwui-button>
    </vwui-modal-footer>
</form>
